'use client';

import { DropdownHeader, DropdownItem, Dropdown as FlowbiteDropdown } from 'flowbite-react';
import { type FunctionComponent, useState } from 'react';

import { Paragraph } from '../paragraph/paragraph';
import type { DropdownItemProps, DropdownProps } from './types';

export const Dropdown: FunctionComponent<DropdownProps> = ({
	menuItems,
	header,
	onClick,
	label,
	isMenu,
	isCalendar,
	textSize = 'lg',
	...props
}) => {
	const customTheme = {
		arrowIcon: 'h-3 w-3 dark:stroke-n700_text_dark_mode',
		content: 'p-0 focus:outline-none',
		inlineWrapper: `flex items-center ${textSize === 'lg' ? 'font-medium' : 'font-normal'} text-${textSize} leading-6 flex-grow disabled:cursor-not-allowed disabled:opacity-40 w-[max-content]`,
		floating: {
			animation: 'transition-opacity',
			base: 'z-30 rounded-lg shadow-dropdown focus:outline-none p-0',
			item: {
				container: 'hover:bg-n50_hover dark:hover:bg-n600_text first:hover:rounded-t-lg last:hover:rounded-b-lg',
				base: 'flex w-full cursor-pointer items-center justify-start focus:outline-none',
				icon: '',
			},
			divider: 'my-1 h-px bg-n200_background',
		},
	};

	const [selected, setSelected] = useState(menuItems[0]);

	const renderHeader = () => {
		const isStringHeader = typeof header === 'string';
		return (
			<DropdownHeader>
				{isStringHeader ? (
					<Paragraph variant='text-base-medium' className='min-w-40'>
						{header}
					</Paragraph>
				) : (
					header
				)}
			</DropdownHeader>
		);
	};

	const handleClick = (item: DropdownItemProps) => {
		if (onClick) {
			onClick;
		}
		setSelected(item);
	};

	return (
		<FlowbiteDropdown
			{...props}
			theme={
				isCalendar
					? {
							...customTheme,
							inlineWrapper: 'flex items-center font-semibold text-sm leading-6',
							arrowIcon: 'ml-2',
							floating: {
								...customTheme.floating,
								base: 'z-10 rounded-lg shadow-dropdown focus:outline-none p-0 h-44 overflow-auto',
							},
						}
					: customTheme
			}
			label={isMenu ? label : (selected?.label ?? label)}
		>
			{header && renderHeader()}
			{menuItems?.length > 0 &&
				menuItems.map((item) => (
					<DropdownItem key={item.value} onClick={isMenu ? item.onClick : () => handleClick(item)}>
						{item.label}
					</DropdownItem>
				))}
		</FlowbiteDropdown>
	);
};
